import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/licensesSlice";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetLicensesQuery } from "../services/licenses.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { getQueryStatus } from "../utils";
import Filter from "./filter/Filter";
import LicenseDetails from "./licenseDetails/LicenseDetails";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "name",
        label: "SPDX ID",
        sortProperty: "name",
        sortId: "licenses-sort-name",
        width: "100%",
    },
    {
        id: "family",
        label: "Family",
        sortProperty: "family",
        sortId: "licenses-sort-family",
        width: "200px",
    },
    {
        id: "violations",
        label: "Issues",
        sortProperty: "violations",
        sortId: "licenses-sort-violations",
        width: "100px",
    },
    {
        id: "references_count",
        label: "Components",
        sortProperty: "references_count",
        sortId: "licenses-sort-references",
        width: "140px",
    },
    { id: "audit", label: "Audit", width: "80px" },
];
const LicensesContent = () => {
    var _a;
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const { reportId, diffId } = useContext(ReportContext);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data = { licenses: [], match_count: 0 }, isLoading, isFetching, isError, error, } = useGetLicensesQuery({
        ui_id: reportId,
        filter,
        sort,
        pagination,
    });
    const handleSortChange = (newSort) => {
        dispatch(sortUpdated(newSort));
    };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Licenses", details: [
                formatCount((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.total_licenses) !== null && _a !== void 0 ? _a : 0, "License"),
            ] }),
        React.createElement(Page.Filters, { found: {
                id: "licenses-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "licenses",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "licenses-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.licenses.map((licenseInfo, index) => (React.createElement(LicenseDetails, { key: licenseInfo.spdx_id, licenseInfo: licenseInfo, index: index })))))));
};
const Licenses = () => {
    return (React.createElement(ErrorBoundary, { key: "licenses" },
        React.createElement(LicensesContent, null)));
};
export default Licenses;
//# sourceMappingURL=Licenses.js.map